<template>
  <div id="app">
    <!-- <Index msg="Welcome to Your Vue.js App" /> -->

    <router-view></router-view>
  </div>
</template>

<script>
export default {
  name: "App"
};
</script>

<style>
#app {
  font-family: Avenir, Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  color: #2c3e50;
}
html,
body {
  background: #5d52cc;
  min-height: 100%;
}

body {
  width: 540px;
  margin: 0 auto !important;
}

body,
p,
span {
  margin: 0;
}
</style>
